module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 /* allowHtmlVariables registrationForm */ 
__p+='\n<div class="t-registration-modal js-registration-modal">\n    <div class="modal__header modal__header-thin">\n        <button class="t-modal-close modal__close" data-dismiss="modal">\n            <i class="icon icon-large icon-crossRound-midGrey"></i>\n        </button>\n    </div>\n    <div class="modal__body modal__body-wide registrationModalBodySpacing">\n        <div class="js-registration-form"></div>\n    </div>\n</div>\n';
}
return __p;
};
